module.exports = __webpack_public_path__ + "702d908e99d18ac322552938818fcd21.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/commit/font/iconfont.ttf?t=1551778644856
// module id = 817
// module chunks = 9